import { Group } from "@mantine/core"
import { SuperAdminVenueBookingTabs } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingTabs"
import { EditSuperAdminVenueBookingAction } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingActions"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { formatDate, formatTime } from "src/utils/dates"
import { SuperAdminVenueBookingView } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingView"

export function SuperAdminVenueBookingOverlay() {

    const { currentItem } = useAppState(state=>state.bookings)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.talent?.alias} ${formatDate(currentItem?.date)} ${!!currentItem?.set_start_time ? '@ ': ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminVenueBookingAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminVenueBookingTabs overlay/>
            <SuperAdminVenueBookingView/>
        </DrawerPageLayout>
    )

}